import React, { useCallback } from 'react';
import { array, bool, func, shape } from 'prop-types';

import { groupBy } from 'lodash';

import TagSelect from '../../components/FormFields/TagSelect';

const PrioritiesFilter = ({
    disabled,
    prioritiesFilter,
    onChangePrioritiesFilter,
    ...props
}) => {
    const changeHandler = (defaultValues = {}) => {
        return (event) => {
            const { value } = event.target;
            const groupedValues = groupBy(value, 'type');
            const newValues = { ...defaultValues };
            Object.entries(groupedValues).forEach(([type, value]) => {
                newValues[type] = value;
            });
            onChangePrioritiesFilter(newValues);
        };
    };

    const handleChange = useCallback(
        changeHandler({
            priorities: []
        })
    );

    const options = [
        {
            items: [
                {
                    id:   1,
                    name: 'High'
                },
                {
                    id:   2,
                    name: 'Medium'
                },
                {
                    id:   3,
                    name: 'Low'
                },
                {
                    id:   4,
                    name: 'No Priority'
                }
            ],
            name:      'Priorities',
            itemProps: {
                type: 'priorities'
            }
        }
    ];

    const value = [...prioritiesFilter.priorities];

    return (
        <TagSelect
            disabled={disabled}
            grouped
            kickerText="Add any combination of Priorities to filter by these items."
            label="Priorities"
            name={undefined}
            onChange={handleChange}
            options={options}
            placeholder="Add Priority"
            value={value}
            {...props}
        />
    );
};

PrioritiesFilter.defaultProps = {
    prioritiesFilter: {
        priorities: []
    },
    disabled:                 false,
    onChangePrioritiesFilter: () => {}
};

PrioritiesFilter.propTypes = {
    prioritiesFilter: shape({
        priorities: array.isRequired
    }),
    disabled:                 bool,
    onChangePrioritiesFilter: func.isRequired
};

export default PrioritiesFilter;
